import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { FeBundleApi } from '../api/fe-bundle.api';
import { ClientContext, ClientContextApi } from '../api/client-context.api';
import { reportHostError } from '../../datadog';

@injectable()
export class FeBundleStore {
    @observable
    feLoading = false;

    @observable
    bundleUrl?: string = '';

    @observable
    isError = false;

    @observable
    clientContext: ClientContext | null = null;

    constructor(
        @inject(FeBundleApi) private readonly feBundleApi: FeBundleApi,
        @inject(ClientContextApi) private readonly clientContextApi: ClientContextApi,
    ) {
        makeObservable(this);
    }

    @action
    init = async (isPilot: boolean, isLegacy: boolean) => {
        try {
            this.feLoading = true;
            const [bundleResult, contextResult] = await Promise.allSettled([
                this.feBundleApi.getPackageUrl(isPilot, isLegacy),
                this.clientContextApi.getClientContext(),
            ]);

            runInAction(() => {
                if (bundleResult.status === 'fulfilled') {
                    this.bundleUrl = bundleResult.value.data;
                } else {
                    this.isError = true;
                    reportHostError('cpb-host: bundle URL request failed', {
                        isPilot,
                        isLegacy,
                        reason: String(bundleResult.reason),
                    });
                }
                if (contextResult.status === 'fulfilled') {
                    this.clientContext = contextResult.value.data;
                } else {
                    reportHostError('cpb-host: client context request failed', {
                        reason: String(contextResult.reason),
                    });
                }
            });
        } finally {
            runInAction(() => {
                this.feLoading = false;
            });
        }
    };
}
